import React from "react";
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import Noc from "components/presentation/Noc";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from 'components/common/SportCode'
import { getIsIndividual } from "components/sports/sjp/helper/SjpHelpers";
import { getUnitRSC } from "helpers/rsc";

const SjpExpanded = ({ row, extendedResults, judges }) => {
    const { mirs_discipline, mirs_rsc } = useUrlFriendlyToParameters()

    const isIndividual = getIsIndividual(mirs_rsc);
    const qual = getUnitRSC(mirs_rsc).includes('QUAL0001')
    let distance, speed, gate, gatePoints, wind, compensationPoints, nocA, nocB, nocC, nocD, nocE, nocF, judgePoints, roundPoints, gateChange, totalPoints, rank = ''
    if (row?.resultType !== 'IRM') {
        distance = findArray(extendedResults, { er_code: ['DIST'] })
        speed = findArray(extendedResults, { er_code: ['SPEED'] })?.er_value
        gate = findArray(extendedResults, { er_code: ['GATE_NUM'] })?.er_value
        gatePoints = findArray(extendedResults, { er_code: ['GATE_NUM'] })?.er_value2
        wind = findArray(extendedResults, { er_code: ['WIND_SPEED'] })
        compensationPoints = findArray(extendedResults, { er_code: ['TOT'] })?.er_value

        nocA = extendedResults ? findArray(extendedResults, { er_code: ['A'] }) : ''
        nocB = extendedResults ? findArray(extendedResults, { er_code: ['B'] }) : ''
        nocC = extendedResults ? findArray(extendedResults, { er_code: ['C'] }) : ''
        nocD = extendedResults ? findArray(extendedResults, { er_code: ['D'] }) : ''
        nocE = extendedResults ? findArray(extendedResults, { er_code: ['E'] }) : ''
        nocF = extendedResults ? findArray(extendedResults, { er_code: ['F'] }) : ''
        judgePoints = extendedResults ? findArray(extendedResults, { er_code: ['TOT'], er_type: ['JUDGE'] })?.er_value : ''

        roundPoints = extendedResults ? findArray(extendedResults, { er_code: ['PTS'] })?.er_value : ''

        //extendedResultsCurrent
        gateChange = extendedResults?.find(i => i?.er_code === 'GATE_NUM')?.extensions?.find(i => i?.ere_code === 'GATE_CHANGE') ? extendedResults?.find(i => i?.er_code === 'GATE_NUM')?.extensions?.find(i => i?.ere_code === 'GATE_CHANGE')?.ere_value : ''
        totalPoints = row?.resultData
        rank = row?.resultRank
    }

    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderDistance" /></th>
                    </tr>
                    <tr>
                        <th className="text-center w-30" scope="row"><Label data="HeaderDistanceM" sport={mirs_discipline} /></th>
                        <td>
                            {row?.resultType === 'IRM'
                                ? <SportCode discipline={mirs_discipline} entity='@IRM' code={row?.resultIrm} abbr={true} />
                                : row?.resultIrm === 'IRF'
                                    ? <SportCode discipline={mirs_discipline} entity='@IRF' code={row?.resultIrm} abbr={true} />
                                    : row?.resultType === 'POINTS'
                                        ? distance?.er_value
                                        : ''
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderDistancePoints" sport={mirs_discipline} /></th>
                        <td className="fw-bold">{distance?.er_value2}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderSpeedKmH" sport={mirs_discipline} /></th>
                        <td className="fw-bold">{speed}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderJudges" sport={mirs_discipline} /></th>
                    </tr>
                    <tr>
                        <th className="d-flex justify-content-center fw-bold" scope="row">
                            <Label data="HeaderJudgeA" sport={mirs_discipline} />&emsp;
                            <Noc {...judges[0]?.official?.organisation} />
                        </th>
                        {nocA?.er_discard === 'Y'
                            ? <td className="fw-bold text-decoration-line-through">{nocA?.er_value}</td>
                            : <td className="fw-bold">{nocA?.er_value}</td>
                        }
                    </tr>
                    <tr>
                        <th className="d-flex justify-content-center fw-bold" scope="row">
                            <Label data="HeaderJudgeB" sport={mirs_discipline} />&emsp;
                            <Noc {...judges[1]?.official?.organisation} />
                        </th>
                        {nocB?.er_discard === 'Y'
                            ? <td className="fw-bold text-decoration-line-through">{nocB?.er_value}</td>
                            : <td className="fw-bold">{nocB?.er_value}</td>
                        }
                    </tr>
                    <tr>
                        <th className="d-flex justify-content-center fw-bold" scope="row">
                            <Label data="HeaderJudgeC" sport={mirs_discipline} />&emsp;
                            <Noc {...judges[2]?.official?.organisation} />
                        </th>
                        {nocC?.er_discard === 'Y'
                            ? <td className="fw-bold text-decoration-line-through">{nocC?.er_value}</td>
                            : <td className="fw-bold">{nocC?.er_value}</td>
                        }
                    </tr>
                    <tr>
                        <th className="d-flex justify-content-center fw-bold" scope="row">
                            <Label data="HeaderJudgeD" sport={mirs_discipline} />&emsp;
                            <Noc {...judges[3]?.official?.organisation} />
                        </th>
                        {nocD?.er_discard === 'Y'
                            ? <td className="fw-bold text-decoration-line-through">{nocD?.er_value}</td>
                            : <td className="fw-bold">{nocD?.er_value}</td>
                        }
                    </tr>
                    <tr>
                        <th className="d-flex justify-content-center fw-bold" scope="row">
                            <Label data="HeaderJudgeE" sport={mirs_discipline} />&emsp;
                            <Noc {...judges[4]?.official?.organisation} />
                        </th>
                        {nocE?.er_discard === 'Y'
                            ? <td className="fw-bold text-decoration-line-through">{nocE?.er_value}</td>
                            : <td className="fw-bold">{nocE?.er_value}</td>
                        }
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderJudgesPoints" /></th>
                        <td className="fw-bold">{judgePoints}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderCompensation" /></th>
                    </tr>
                    <tr>
                        <th className="text-center w-30" scope="row"><Label data="HeaderGate" /></th>
                        <td>{gate}&ensp;
                            {gateChange === 'C'
                                ? <Label data="HeaderCoachDecision" sport={mirs_discipline} />
                                : ''
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className="text-center w-30" scope="row"><Label data="HeaderGatePoints" sport={mirs_discipline} /></th>
                        <td>{gatePoints}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30" scope="row"><Label data="HeaderWindMS" sport={mirs_discipline} /></th>
                        <td>{wind?.er_value}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30" scope="row"><Label data="HeaderWindPoints" sport={mirs_discipline} /></th>
                        <td>{wind?.er_value2}</td>
                    </tr>
                    <tr>
                        <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderCompensationPoints" sport={mirs_discipline} /></th>
                        <td className="fw-bold">{compensationPoints}</td>
                    </tr>
                    {isIndividual || qual
                        ?
                        <>
                            <tr>
                                <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderTotalPoints" /></th>
                                <td className="fw-bold">{totalPoints}</td>
                            </tr>
                            <tr>
                                <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderRank" /></th>
                                <td className="fw-bold">{rank}</td>
                            </tr>
                        </>
                        :
                        <>
                            <tr>
                                <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderRoundPointsMix" /></th>
                                <td className="fw-bold">{roundPoints}</td>
                            </tr>
                        </>
                    }
                </thead>
            </table>
        </>
    )

}

export default SjpExpanded;